import './AudioVoiceSelector.sass';

import { createRef, useEffect, useState } from 'react';

import { voices } from '../../constants/audioVoices';

function AudioVoiceSelector({ onSelectVoice }) {
  const [selectedVoice, setSelectedVoice] = useState(voices[0]);
  const audioRef = createRef();

  useEffect(() => {
    onSelectVoice(voices[0]);
  }, []);

  const handleChange = (event) => {
    const voice = voices.find((v) => v.name === event.target.value);
    setSelectedVoice(voice);
    onSelectVoice(voice);
  };

  const testSelectedVoice = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  return (
    <div className="voiceSelector">
      <select value={selectedVoice.name} onChange={(e) => handleChange(e)}>
        {voices.map((voice) => (
          <option key={voice.name} value={voice.name}>
            {voice.name}
          </option>
        ))}
      </select>
      <i
        className="fa fa-volume-up fa-lg icon-button"
        title="Test voice"
        onClick={testSelectedVoice}
      />
      <audio ref={audioRef} src={selectedVoice.example ?? ''}>
        <track kind="captions" />
      </audio>
    </div>
  );
}

export default AudioVoiceSelector;
